import { Outlet } from "react-router-dom";

const Layout = () => {
  return (
    <div className="flex flex-col w-full h-full pt-2 pl-4 pr-4">
      {/* 内容区域 - 固定高度不滚动 */}
      <div className="flex-1 min-h-0 pt-2">
        <Outlet />
      </div>
    </div>
  );
};

export default Layout;
